<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@font-face { font-family:'electronicFont'; src: url("/font/DS-DIGIT.TTF"); }
@font-face {
  font-family: 'iconfont';  /* project id 2462894 */
  src: url('//at.alicdn.com/t/font_2462894_14f2eok98pc9.eot');
  src: url('//at.alicdn.com/t/font_2462894_14f2eok98pc9.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_2462894_14f2eok98pc9.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_2462894_14f2eok98pc9.woff') format('woff'),
  url('//at.alicdn.com/t/font_2462894_14f2eok98pc9.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_2462894_14f2eok98pc9.svg#iconfont') format('svg');
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  /* background-color: #100C2A; */
  /* background: url(./nybj.png); */
  background: url(./admobilebackgroundimg.png) no-repeat center;
  background-size: 20rem 20rem;
  background-color: #161616;
  /* background-size: 40% 40%; */
  overflow:-Scroll;
  overflow-x:hidden;
  overflow:-Scroll;
  overflow-y:hidden;
  margin: 0;
  padding: 0;
}
.el-tabs__nav{
  width: 100% !important;
  height: 8vh;
  line-height: 8vh;
  border: none !important;
}
.el-tabs__item{
  width: 12.5%;
  border: none !important;
  text-align: center;
  padding: 0 0 0 2vh;
  color: #b0b0b0;
  font-size: 0.8vw;
  box-sizing: border-box;
}
.el-tabs__header{
  border-bottom: none !important;
  margin: 0;
  /* padding: 1.8vh 0; */
  background-image: linear-gradient(to right,#131834,#1A1C68,#151830);
}
.el-tabs__item.is-active {
  color: #ffffff;
  font-size: 1vw;
  font-weight: 600;
}
.el-tabs__item.is-active:before {
  position: absolute;
  top: 40%;
  right: 2vw;
  bottom: 16px;
  left: 2.9vw;
  border-radius: 10%;
  content: '';
  z-index: 1;
  box-shadow: 0 20px 20px #3c41d4;
}
</style>



// WEBPACK FOOTER //
// src/App.vue